import { getFeatureFlag } from '@americanexpress/one-xp-client-sdk';

export const getMycaLoginFlag = (state) => {
  return getFeatureFlag(state, { featureFlagName: 'LoungeFinder_mycaLogin' });
};
